import {attachmentId, pixelBufferType, primitiveType, RBIntFormat} from "_src/engine/constants";

import Pass from "_src/render_graph/pass";
import resourceManager from "_src/render_graph/resource_manager";

import objFactory from "_src/engine/factories/object";
import FrameBuffer from "_src/engine/framebuffer";
import primitiveFactory from "_src/engine/factories/primitive";

import UpdateDepthShader from "_src/shaders/update_depth/update_depth";
import config from "_src/config";
import GL from "_src/engine/gl";

export default class UpdateDepthPass extends Pass {

  constructor(attachmentsStorage, camera, screenQuadCamera) {

    super(attachmentsStorage);

    this.init(camera, screenQuadCamera);

  }

  init(camera, screenQuadCamera) {
    const updateDepthScene = this._addScene(screenQuadCamera);
    const gridScene = this._addScene(camera);

    updateDepthScene.clearedColor = false;
    updateDepthScene.clearedDepth = config.recalculateInterfaceDepth;
    updateDepthScene.clearedStencil = config.recalculateInterfaceDepth;

    gridScene.clearedColor = false;
    gridScene.clearedDepth = false;
    gridScene.clearedStencil = false;

    if (config.recalculateInterfaceDepth) {
      const screenChunk = primitiveFactory.create(primitiveType.SCREEN_QUAD);
      const updateDepthShader = new UpdateDepthShader({transparent: false, depthTest: true});
      const updateDepthPlane = objFactory.createDrawable(updateDepthShader);
      updateDepthPlane.addGeometryChunk(screenChunk);
      updateDepthScene.add(updateDepthPlane);
    }
  }

  update() {

    const updateDepthScene = this.getMainScene();
    const gridScene = this.getSecondScene();

    const width = updateDepthScene.camera.viewport[2];
    const height = updateDepthScene.camera.viewport[3];

    const {updateDepthFrameBuffer, gridFrameBuffer} = this.initFramebuffer(width, height);

    updateDepthScene.setFramebuffer(updateDepthFrameBuffer);
    gridScene.setFramebuffer(gridFrameBuffer);

    if (config.recalculateInterfaceDepth) {
      const updateDepthPlane = updateDepthScene.getChildren()[0];
      updateDepthPlane.setTexture(this.attachmentsStorage[attachmentId.WORKSPACE_DEPTH_STENCIL], 0);
    }

  }

  initFramebuffer(width, height) {
    const colorTexture = this.attachmentsStorage[attachmentId.BASE_COLOR_TEXTURE];
    const tmpColorTexture = resourceManager.initBuffer(pixelBufferType.RB_RGBA,
        { width, height });

    if (!this.attachmentsStorage[attachmentId.INTERFACE_DEPTH]) {
      const format = GL.checkWebGL2() ? RBIntFormat.D24S8 : RBIntFormat.DS;
      this.attachmentsStorage[attachmentId.INTERFACE_DEPTH] = resourceManager.initBuffer(pixelBufferType.RB_DEPTH, { width, height, format });
    }
    const depth = this.attachmentsStorage[attachmentId.INTERFACE_DEPTH];

    const updateDepthFrameBuffer = new FrameBuffer([tmpColorTexture], depth);
    const gridFrameBuffer = new FrameBuffer([colorTexture], depth);

    return {updateDepthFrameBuffer, gridFrameBuffer};
  }

}
